import { styled, Text, spacing } from '@thg-commerce/gravity-theme'
import { borderInfo } from '../FormItem/Input/Styles'

export const Label = styled.label`
  ${Text('bodyText', 'alternate')}
  margin: ${spacing(1)} 0;
  color: ${(props) => props.theme.colors.palette.accent.darker};
`

export const StyledTextArea = styled.textarea`
  ${Text('small', 'default')};
  border-radius: 4px;
  height: 144px;
  margin: 0 0 ${spacing(1)} 0;
  padding: ${spacing(1)};
  width: 100%;
  resize: none;
  outline-color: ${(props) => props.theme.colors.palette.accent.light};
  ${borderInfo('default')}

  &:hover {
    ${borderInfo('hover')}
  }
`

export const CharacterCount = styled.div`
  ${Text('small', 'default')};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 20px;
  color: ${(props) => props.theme.colors.palette.accent.darker};
}
`
